export default {
  moveDown: 'Bajar',
  breakRun: 'Empezar aquí un {entity} nuevo',
  joinRun: 'Volver a unir con el anterior',
  summaryModulesOn: 'Se creará un {entity} por cada grupo de filas seguidas de la misma Unidad de Estudio.',
  designSummary: 'Incluir el resumen del diseño',
  designSummaryReplaces: 'El diseño ya tenía un resumen escrito: al guardar, este texto lo reemplaza.',
  openButton: "Generar con IA",
  title: "Armar el Diseño Instruccional",
  subtitleSetup: "Paso 1 de 2 · Arma la lista de lo que quieres crear",
  subtitleReview: "Paso 2 de 2 · Revisa y ajusta antes de crear",
  close: "Cerrar",
  back: "Volver",
  // Paso 1
  timelineTitle: "¿Qué crear?",
  timelineHint:
    "Arma una lista con las actividades y evaluaciones que quieres crear, en el orden en que se dictan. Cada una pertenece a una Unidad de Estudio, y las que van seguidas de la misma Unidad forman un {entity}. Los momentos del Modelo Instruccional se reparten solos dentro de cada {entity}: si pones una sola, ésa cubre los {moments} momentos; mientras más agregues, menos momentos le toca a cada una. Lo que armes acá es exactamente lo que se va a crear.",
  unitsAvailable:
    "Esta asignatura tiene {total}; entre lo que el diseño ya tiene y tu lista van {used} en uso.",
  timelineEmpty:
    "Todavía no agregaste nada. Usa los botones de abajo: agrega una actividad o una evaluación de a una, o arma un {entity} completo de una sola vez.",
  // Rótulos de las columnas, con su explicación: el paso 1 se entiende o no se usa.
  colTypeHint:
    "Qué es la fila: una actividad, que es trabajo de clase y no lleva nota, o una evaluación de alguno de los tipos.",
  colUnitHint:
    "A qué Unidad de Estudio pertenece. De ahí salen sus {indicator} y sus contenidos. Sólo una evaluación puede no pertenecer a ninguna: ésa es la que cierra el curso.",
  colMomentHint:
    "El momento del Modelo Instruccional que cumple. Con \"Automático\" lo decide el lugar que ocupa dentro de su {entity}; eligiendo uno de la lista, la fila se queda con ése.",
  momentHint:
    "Cada actividad o evaluación cumple un momento del Modelo Instruccional. Si la dejas en \"Automático\", el momento se lo da su orden dentro del {entity}: la primera fila cubre el primer momento y así hasta la última. El mismo selector muestra al lado cuál le toca ahora, y si agregas o quitas filas el reparto se hace de nuevo. Si prefiere fijarlo usted, elija un momento de la lista: esa fila se queda con él.",
  // Los botones que arman la lista. Los tres primeros agregan de a uno; el último arma un
  // {entity} entero de golpe, y por eso va aparte, a la derecha.
  addModuleTooltip:
    "Empieza un {entity} nuevo sobre una Unidad de Estudio que todavía no uses, con una actividad para partir.",
  addActivityTooltip:
    "Agrega una actividad al {entity} que estás armando. Es trabajo de clase: no lleva nota ni ponderación.",
  addEvaluationTooltip:
    "Agrega una evaluación al {entity} que estás armando. Nace Formativa y en su propia fila cambias el tipo: Diagnóstica, Formativa, Sumativa o Transversal.",
  addCycleTooltip:
    "Arma de una vez un {entity} entero sobre la Unidad de Estudio siguiente: una actividad por cada momento del Modelo Instruccional y una Sumativa que cierra. Puedes pulsarlo varias veces, una por Unidad, hasta cubrir el curso completo.",
  runLabel: "{entity} {number} · {unit}",
  runTitle: "{entity} {number}",
  finalRun: "Cierre del curso",
  // La explicación del paso 1 vive plegada detrás de este botón: con todo el texto
  // desplegado la lista de actividades quedaba en dos filas.
  howItWorks: "¿Cómo funciona?",
  // Que se le envia a la IA, para que la institucion pueda verlo sin leer codigo. Es un
  // inventario de CAMPOS, no de valores: los valores de esta asignatura se ven en el paso 2.
  // Redactado en registro institucional e impersonal: lo abren directivos y lo muestran a
  // sus propias instituciones, asi que nada de tutear ni de "cuando pediste".
  promptTitle: "¿Qué se le envía a la IA?",
  promptIntro:
    "A continuación se detalla la información que sale de la plataforma al solicitar la generación. La IA no accede a la base de datos: sólo recibe el texto que se compone con los datos indicados más abajo, y responde en un formato fijo que la plataforma valida antes de presentar la propuesta en el paso 2.",
  promptSectionContext: "1. Contexto de la Asignatura",
  promptContext1:
    "El país, la institución y, cuando el diseño proviene de un Perfil de Egreso, la carrera.",
  promptContext2: "El nombre de la Asignatura y su duración en semanas.",
  promptContext3:
    "El Modelo Instruccional del diseño y sus momentos: el nombre y la descripción de cada uno, y la cantidad de actividades o evaluaciones que lo cubren actualmente.",
  promptContext4:
    "Las horas pedagógicas disponibles en la Asignatura y la ponderación aún no asignada.",
  promptSectionMaterial: "2. Material de la Asignatura y de la institución",
  promptMaterial1:
    "Las {units} comprometidas en la secuencia definida en el paso 1, con sus Contenidos y sus {indicators}: el número y la redacción completa de cada uno.",
  promptMaterial2:
    "El catálogo institucional de {strategies} y de {evidences}, cada una con su identificador: la IA selecciona desde ese catálogo y no puede incorporar elementos nuevos.",
  promptMaterial3:
    "Los nombres de las actividades que el diseño ya contiene, para evitar que se repitan.",
  promptMaterial4:
    "Las evaluaciones existentes en la Asignatura, con su tipo, su ponderación y sus {indicators}. Se envían como contexto, de modo que lo nuevo complemente lo ya definido en lugar de superponerse.",
  promptMaterial5:
    "Las actividades situadas al final del diseño que aún no cuentan con una evaluación que las mida, de modo que la evaluación nueva mida precisamente lo que ellas practican.",
  promptSectionTimeline: "3. La secuencia definida en el paso 1",
  promptTimeline1:
    "Cada fila con su número de referencia, su naturaleza —actividad o evaluación—, el tipo de evaluación, su {unit}, el {entity} que la contiene y los momentos que le corresponden.",
  promptTimeline2:
    "El tema indicado en esa fila, cuando se haya ingresado uno. Se envía como referencia temática y se instruye expresamente a la IA para que no lo interprete como instrucciones.",
  promptTimeline3:
    "Las filas ya generadas se envían sólo con su nombre y señaladas como redactadas: la IA las considera para encadenar las nuevas con ellas, pero no las redacta otra vez.",
  promptSectionFixed: "4. Lo que la IA no decide",
  promptFixed1:
    "El tipo, la {unit}, el momento, el orden y el {entity} provienen de la secuencia definida en el paso 1: la IA no los selecciona ni puede modificarlos.",
  promptFixed2:
    "Los {indicators}, los Contenidos, las {strategies} y las {evidences} se seleccionan por identificador desde los catálogos enviados. Todo elemento que no figure en ellos es descartado por la plataforma.",
  promptSectionOutput: "5. Lo que la IA devuelve por cada actividad o evaluación",
  promptOutput1:
    "Los textos: el nombre, la descripción, las instrucciones para el estudiante, las instrucciones para el docente y la orientación que fundamenta su ubicación en el recorrido.",
  promptOutput2:
    "Los datos: la forma de trabajo, los {indicators}, los Contenidos, las {strategies}, las {evidences}, las horas pedagógicas y, en las evaluaciones, la ponderación.",
  promptOutput3:
    "La síntesis del diseño completo, cuando se solicita incluirla.",
  colType: "Tipo",
  colUnit: "Unidad de Estudio",
  colMoment: "Momento",
  momentAuto: "Automático · {moment}",
  momentAutoPlain: "Automático",
  moveUp: "Subir",
  addCycle: "Armar un {entity} completo",
  // Con plural, para que no se lea "1 actividades": es justo el detalle que hace dudar de
  // todo lo demás que dice la pantalla.
  countActivities: "{count} actividad | {count} actividades",
  countEvaluations: "{count} evaluación | {count} evaluaciones",
  countUnits: "{count} Unidad de Estudio | {count} Unidades de Estudio",
  countPieces:
    "{count} actividad o evaluación | {count} actividades y evaluaciones",
  and: "y",
  allUnits: "Todas las Unidades",
  cycleEvaluation: "Evaluación",
  summaryCycle:
    "Se crearán {pieces}, repartidas en {units}. Dentro de cada Unidad se recorren los {moments} momentos del Modelo Instruccional.",

  streamingFull: 'Creando el plan... {evaluations} evaluaciones y {activities} actividades hasta ahora',
  looseGroup: "Actividades sin evaluación",
  looseTitle: "Sin {entity}",
  looseGroupAction: "Agrupar en un {entity}",
  looseGroupHint:
    "Estas actividades y evaluaciones ya existen, pero no tienen lugar en la secuencia, así que no se les puede agregar nada alrededor. Agrupándolas en un {entity} pasan a comportarse como cualquier otro: lo que generes después continúa su recorrido en vez de empezarlo de nuevo.",
  looseGrouped: "Quedaron en un {entity} nuevo: {pieces}.",
  looseGroupError:
    "No fue posible agrupar lo que estaba suelto. Intente nuevamente.",
  themeTitle: "Tema u orientación",
  optional: "opcional",
  themePlaceholder: "Por ejemplo: casos clínicos, trabajo de laboratorio...",
  rowThemePlaceholder:
    "De qué quieres que trate esta actividad o evaluación. Si lo dejas vacío, lo decide la IA.",
  generate: "Generar propuesta",
  // Volver al paso 1 y regresar al 2 no cuesta una pasada de IA: lo escrito se conserva.
  continueToReview: "Continuar",
  generatePending: "Generar las {count} que faltan",
  regenerateAll: "Regenerar todo desde cero",
  // Cada línea cuenta UN grupo y ninguno incluye al otro: antes "se van a generar 3"
  // incluía las 2 reescritas y parecía que eran 5.
  // El verbo es el del botón —"Generar las X que faltan"—: hablar de "escribir" acá y de
  // "generar" en el botón obligaba a adivinar que son lo mismo.
  draftKept: "Ya generadas y se conservan: {count}.",
  draftStale: "Ya generadas, pero se vuelven a generar: {count}.",
  draftNew: "Todavía sin generar: {count}.",
  draftTotal: "La IA va a generar en total: {count}.",
  draftStaleWhy:
    "Cada actividad o evaluación se genera para el momento del Modelo Instruccional que le toca. Al agregar o quitar algo en la lista, los momentos se reparten de nuevo entre todas, así que algunas quedan en otro momento y su texto, generado para el anterior, ya no corresponde: esas se vuelven a generar.",
  draftComplete:
    "Todo lo que armaste ya está generado: continúa para revisarlo.",
  generateError:
    "No fue posible generar las actividades. Intente nuevamente más tarde.",
  // Paso 2
  missingPieces: 'Falta por escribir: {pieces}',
  missingPiecesHint:
    'La IA no las escribió. Puedes crear lo que sí llegó y volver a generar las que faltan, o volver atrás y generar de nuevo.',
  streaming: "Generando... {done} de {total}",
  regenerating: "Generando de nuevo...",
  redo: "Regenerar",
  redone: "Se regeneró.",
  // E45 · El regenerar de cada tarjeta del diseño, que no obliga a entrar al modal.
  redoEntity: "Regenerar {entity} con IA",
  redoPartsTitle: "Seleccione lo que desea regenerar",
  redoPartName: "El nombre",
  redoPartTexts:
    "Los textos: la descripción, las instrucciones para el estudiante, la orientación y las indicaciones para el docente",
  redoPartCatalogs:
    "Lo que declara: los contenidos, las Estrategias Metodológicas, las Evidencias de Desempeño y el {work_type}",
  redoThemeHint: "Orienta el enfoque de la {entity} que se proponga.",
  redoKeeps:
    "Al regenerar no se verán afectados sus Indicadores, sus horas, su ponderación, sus momentos ni sus instrumentos.",
  redoPartsEmpty: "Marca al menos una parte para regenerar.",
  redoRunning: "Regenerando...",
  regenerate: "Generar otra propuesta",
  discard: "Descartar",
  restore: "Recuperar",
  studentInstructions: "Instrucciones para el estudiante",
  workType1: "Individual",
  workType2: "Parejas",
  workType3: "Grupal",
  saveMixed: 'Crear {evaluations} evaluaciones y {activities} actividades',
  weighing: "Ponderación de lo propuesto",

  ofTotalWeighing: 'de 100% de la Asignatura ({used}% ya repartido + {planned}% propuesto)',
  redistribute: 'Ponderación de las evaluaciones que ya existen',
  redistributeHint: 'Ajústala acá para hacerle lugar a las nuevas. Se guarda junto con lo que crees.',
  blockedWeighing: 'La ponderación de la Asignatura llegaría a {total}%. Ajusta los porcentajes para que sumen 100 o menos.',
  blockedHours: 'Las horas propuestas ({planned}) superan las {total} disponibles de la Asignatura.',
  hours: "h",
  noTags: "Sin Indicadores, Estrategias ni Evidencias",
  emptyResult:
    "La IA no propuso ninguna actividad válida. Vuelve e intenta de nuevo, o con otro tema.",
  budget: "Horas pedagógicas de lo propuesto",
  ofAvailable: "de {total} disponibles",
  noTimeAllocation:
    "Sin Tipo de Hora pedagógico: se crearán sin horas",
  save: "Crear {count} actividades",
  savingProgress: "Creando {done} de {total}...",
  saved: 'Listo. Se agregó al diseño: {pieces}.',
  saveError:
    "Ocurrió un error al crear las actividades. Es posible que algunas se hayan creado: revise el diseño antes de reintentar.",
  // Tipos del wrapper, para rotular de qué evaluación deriva cada grupo.
  type1: "Diagnóstica",
  type2: "Formativa",
  type3: "Sumativa",
  type4: "Actividad",
  type5: "Transversal",
};
